<template>
  <div id="adminLogin">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-9 col-md-6 mx-auto">
          <v-card class="login-card mt-7" flat>
            <v-card-title class="justify-content-center">
              <v-img contain height="60" src="../../assets/img/logo.png"></v-img>
            </v-card-title>
            <v-card-text class="px-md-8 py-8">
              <v-form ref="form" v-model="isFormValid">
                <div class="my-4"><i class="fas fa-user primary-text ml-2"></i>نام کاربری</div>
                <v-text-field
                    v-model="userName"
                    :rules="[v => !!v || 'نام کاربری اجباری است']"
                    class="input-border mb-1"
                    dense
                    flat
                    placeholder="نام کاربری"
                    solo>
                </v-text-field>
                <div class="my-4"><i class="fas fa-unlock primary-text ml-2"></i>رمزعبور</div>
                <v-text-field
                    v-model="password"
                    :rules="[v => !!v || 'رمز عبور اجباری است']"
                    class="input-border mb-1"
                    dense
                    flat
                    placeholder="رمزعبور"
                    solo
                    type="password">
                </v-text-field>
                <div class="my-3 text-center">
                  <v-btn :disabled="!isFormValid" class="px-16" color="primary"
                         elevation="0"
                         rounded
                         @click="login">
                    <span class="white--text">ورود</span>
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions class='row'>
              <div class="col-12 px-md-8">
                رمزعبور خود را فراموش کرده اید؟
                <span class="pointer primary-text" @click="forgetPasswordDialog =true">
                  بازیابی رمزعبور
                </span>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="forgetPasswordDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center">
        <v-card-title class="justify-space-between gard-bg">
          <span class="white--text"> بازیابی رمزعبور</span>
          <v-btn
              color="primary"
              class="mr-2"
              icon
              small
              @click="forgetPasswordDialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          برای بازیابی رمز عبور، موبایل خود را وارد کنید.
          <div class="mb-0 black--text py-5">
            <v-text-field
                v-model="phoneNumber"
                :rules="phoneNumberRules"
                class="input-border mb-1"
                dense
                flat
                placeholder="موبایل"
                solo
                type="number">
            </v-text-field>
          </div>
          <v-btn :disabled="phoneNumber === ''" class="white--text" color="primary" elevation="0" rounded
                 @click="recoverPassword">
            دریافت رمز
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <v-btn
              color="primary"
              icon
              small
              @click="showResultDialog = false">
            <i class="fas fa-times font-16 ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        id="loginLoader"
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "AdminLogin",
  metaInfo() {
    return {
      title: 'ادمین تیکتینگ-ورود '
    }
  },
  data: () => ({
    dialogResult: null,
    showResultDialog: false,
    showLoaderDialog: false,
    isFormValid: false,
    userName: null,
    password: null,
    token: null,
    phoneNumber: '',
    forgetPasswordDialog: false,
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
  }),
  mounted() {
    this.$convertFarsiNumber();
  },
  methods:{
    login(){
      this.$router.push({path: '/Admin/Home'})
    },
    recoverPassword(){},
  }
}
</script>

<style scoped>

</style>